import React from "react";
import parse from "html-react-parser";
import { PostSubjectIntroducingProps } from "@/types/modules/post/components";
import styles from "@/styles/post.module.css";
import { PostGalleryLink } from "@/components/modules/Post/Content/PostGalleryLink";
import { PostImage } from "@/components/modules/Post/ContentComponents/PostImage";

export const PostSubjectIntroducing: React.FC<PostSubjectIntroducingProps> = ({
  perex,
  image,
  imageCaption,
  imageSource,
  imageAuthor,
  galleryCount,
  postId,
  postSlug,
  hasGallery,
  allImageSources,
}) => {
  const parsedSrc: string | undefined = image ? (parse(image) as JSX.Element)?.props?.src : undefined;

  return (
    <div className={styles.postContentContainer}>
      {parsedSrc && (
        <div className="relative mt-[20px] flex flex-col lg:mt-[25px]">
          <div
            key={parsedSrc}
            className="flex justify-center [&>div]:!mb-0 [&_figcaption]:mx-auto [&_figcaption]:max-w-[720px] [&_figcaption]:px-4 [&_figcaption]:md:px-0 [&_figure]:mx-auto [&_figure]:max-w-[1066px] [&_img]:w-full"
          >
            <PostImage
              src={parsedSrc}
              source={imageSource}
              authorName={imageAuthor?.name}
              caption={imageCaption}
              allImageSources={allImageSources}
              priority
              disableImgLazyLoading
            />
          </div>
          {!!galleryCount && hasGallery && (
            <div className="!mt-3">
              <PostGalleryLink galleryCount={galleryCount} postId={postId} postSlug={postSlug} />
            </div>
          )}
        </div>
      )}
      {perex && (
        <p className="mb-[24px] mt-[28px] font-mercury text-2xl font-semibold text-dark dark:text-white sm:text-perex lg:mb-[40px] lg:mt-[32px]">
          {perex}
        </p>
      )}
    </div>
  );
};
